'use client';

import type { StructuredContentDocument } from '@cc-shopping/structured-content-renderer/hydration/types';
import { markNestedTypes } from '@cc-shopping/structured-content-renderer/utils';
import { Box } from '@mui/material';
import { Fragment, type ReactNode } from 'react';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';

type Props = {
  description: StructuredContentDocument[];
  linkNodes: ReactNode[];
};

export function BackSide({ description, linkNodes }: Props) {
  return (
    <Box
      sx={{ fontSize: 14, color: 'neutral.darker', cursor: 'text' }}
      onClick={e => e.stopPropagation()}
    >
      {/* Marked nested so `Type` renders a <span> rather than a <p>: the note markers below
          have to sit on the same line as the last words of the body. */}
      {description.map((node, index) => (
        <StructuredContentRenderer key={`back-side-${index}`} doc={markNestedTypes(node)} />
      ))}
      {linkNodes.length > 0 && (
        <>
          {linkNodes.map((node, index) => (
            <Fragment key={index}>
              {node}
              {index < linkNodes.length - 1 && ', '}
            </Fragment>
          ))}
        </>
      )}
    </Box>
  );
}
